var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "i",
            { staticClass: "material-icons", class: _vm.$style.warning },
            [_vm._v(" info_outline ")]
          ),
          _c("div", { class: _vm.$style.texts }, [
            _c("div", [_vm._v(_vm._s(_vm.user.firstName))]),
            _c("div", { class: _vm.$style.subHeader }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("p", { class: _vm.$style.p }, [
            _vm._v(" Hi "),
            _c("b", [_vm._v(_vm._s(_vm.user.firstName) + ",")]),
          ]),
          _c("p", { class: _vm.$style.p }, [
            _vm._v(" " + _vm._s(_vm.message) + " "),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          class: _vm.$style.footer,
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("check-box", {
            attrs: {
              "check-box-value": true,
              "check-box-label": "Don't show this again",
            },
            model: {
              value: _vm.dontShow,
              callback: function ($$v) {
                _vm.dontShow = $$v
              },
              expression: "dontShow",
            },
          }),
          _c("button", { staticClass: "rbButton", attrs: { type: "submit" } }, [
            _vm._v(" Close "),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }